/**
 * Clean WordPress HTML artifacts from content
 * Removes WordPress block editor comments and other artifacts
 */
export function cleanWordPressHtml(html: string | null | undefined): string {
    if (!html) return '';

    let cleaned = html;

    // Remove WordPress block editor comments (<!-- wp:paragraph --> etc)
    cleaned = cleaned.replace(/<!--\s*\/?wp:[^>]*-->/g, '');

    // Remove empty paragraphs
    cleaned = cleaned.replace(/<p>\s*<\/p>/g, '');

    // Remove multiple consecutive spaces
    cleaned = cleaned.replace(/\s+/g, ' ');

    // Trim whitespace
    cleaned = cleaned.trim();

    return cleaned;
}
